module.exports = __webpack_public_path__ + "img/Other.cb45d121.jpg";